<template>
  <div>
    <BaseHeadline icon="mdi-clipboard-alert-outline">
      <template v-slot:headlineBtns>
        <v-btn
          class="mb-0 mr-2"
          color="primary"
          depressed
          @click="downloadOrder(data)"
        >
          <v-icon left>mdi-download</v-icon>
          Last ned bestilling
        </v-btn>
      </template>
    </BaseHeadline>
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      class="my-2"
      color="primary"
      block
      large
      @click="downloadOrder(data)"
    >
      <v-icon left>mdi-download</v-icon> Last ned bestilling
    </v-btn>
    <!-- <v-btn
      v-if="$vuetify.breakpoint.smAndDown && enableActions"
      class="mb-2 mt-2 btnSticky"
      color="primary"
      block
      large
      depressed
      :disabled="!getActivateReceivedGoods"
      @click.once="receiveOrderGoods()"
    >
      <v-icon left large color="success" class="pr-4">mdi-check</v-icon>
      Bekreft varemottak
    </v-btn> -->
    <BaseView v-model="list">
      <template v-slot="{ element }">
        <OrderInfoCard
          v-if="element.type === 'OrderInfoCard'"
          v-model="data"
          :loading="loading"
        />
        <OrderList
          ref="orderLst"
          v-if="element.type === 'ComplaintFloorplanCard'"
          v-model="data"
          :lines.sync="getOrderLines"
          :loading="loading"
          :activateReceivedGoods.sync="getActivateReceivedGoods"
          :enableActions.sync="enableActions"
          @updateAllAllGoodsFullyReceive="updateAllAllGoodsFullyReceive"
          @updateOrderFullyReceive="updateOrderFullyReceive"
          @updateOrderInfo="updateOrderInfo"
          @receiveOrderGoods="receiveOrderGoods()"
        />
      </template>
    </BaseView>
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown && enableActions"
      class="mb-2 mt-2 btnSticky"
      color="primary"
      block
      large
      depressed
      :disabled="!getActivateReceivedGoods"
      @click.once="receiveOrderGoods()"
    >
      <v-icon left large color="success" class="pr-4">mdi-check</v-icon>
      Bekreft varemottak
    </v-btn>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import projectApi from "@/api/projectApi";
import { saveFile } from "@/helpers/files";
import { OrderObject } from "@/types/orderInterface";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import BaseView from "@/components/shared/BaseView.vue";
import OrderInfoCard from "@/components/projects/project/house/orders/order/children/OrderInfoCard.vue";
import OrderList from "@/components/projects/project/house/orders/order/children/OrderList.vue";
import { OrderLines } from "@/types/orderInterface";
import notification from "@/helpers/notification";

export default Vue.extend({
  data() {
    return {
      data: {} as OrderObject,
      loading: false,
      list: {
        lg: [[{ type: "OrderInfoCard" }], [{ type: "ComplaintFloorplanCard" }]],
        md: [[{ type: "OrderInfoCard" }], [{ type: "ComplaintFloorplanCard" }]],
        sm: [[{ type: "OrderInfoCard" }, { type: "ComplaintFloorplanCard" }]],
        xs: [[{ type: "OrderInfoCard" }, { type: "ComplaintFloorplanCard" }]],
      },
      receivedGoodsEnabled: false,
      enableActions: false,
      originalOrders: [],
      success: false,
    };
  },
  async mounted() {
    this.loading = true;
    var orderId = this.$route.params.orderId;

    await projectApi
      .getOrder(orderId)
      .then((response: OrderObject) => {
        this.data = response;
        this.deepCopyOrders(response.orderLines);
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  methods: {
    downloadOrder(order: OrderObject) {
      projectApi.downloadOrder(order.id).then((x) => {
        saveFile(
          x,
          `Bestilling #${order.orderId} ${order.project} fra ${order.contactName}`
        );
      });
    },
    deepCopyOrders(orders: Array<OrderLines>) {
      this.originalOrders = JSON.parse(JSON.stringify(orders));
    },
    setOrderFullyReceive(order: OrderLines) {
      if (
        order.qty &&
        order.qtyAlreadyReceived &&
        order.qtyAlreadyReceived > 0
      ) {
        order.qtyReceived =
          Number(order.qty) - Number(order.qtyAlreadyReceived);
      } else {
        order.qtyReceived = Number(order.qty);
      }
      order.receivedGoodsAction = 0; //Rapporter fullt mottak
    },
    updateOrderInfo(orderInfo: OrderLines) {
      const ix = this.getOrderLines.findIndex(
        (i) => i.componentId === orderInfo.componentId
      );
      this.data.orderLines[ix] = JSON.parse(JSON.stringify(orderInfo));
    },
    updateOrderFullyReceive(order: OrderLines, selected: boolean) {
      if (selected) {
        this.setOrderFullyReceive(order);
      } else {
        const orderOrg = this.originalOrders.filter(
          (o: OrderLines) => o.componentId === order.componentId
        )[0] as OrderLines;

        const index = this.getOrderLines.findIndex(
          (i) => i.componentId === order.componentId
        );

        this.data.orderLines[index] = JSON.parse(JSON.stringify(orderOrg));
      }
    },
    updateAllAllGoodsFullyReceive(selected: boolean) {
      if (selected) {
        this.getOrderLines.forEach((order) => {
          this.setOrderFullyReceive(order);
        });

        //this.$set(this.data, "orderLines", lines);
      } else {
        this.getOrderLines = JSON.parse(JSON.stringify(this.originalOrders));
      }
    },
    async receiveOrderGoods() {
      this.loading = true;
      this.data.orderLines.forEach((o) => {
        if (!o.qtyReceived) {
          o.qtyReceived = 0;
          o.receivedGoodsAction = 2; //default delmottak
        }
      });

      await projectApi
        .receiveOrderGoods(this.data.orderId, this.data.orderLines)
        .then((response) => {
          setTimeout(() => {
            this.$router.go(0);
          }, 500);

          this.loading = false;
          this.success = response.data;
          if (this.success) {
            notification.success("Varemottak vellykket.");
          } else {
            notification.warn("Noe gikk galt med varemottak.");
          }
        })
        .catch(() => {
          this.$router.go(0);
          this.loading = false;
          notification.warn("Noe gikk galt med varemottak.");
          this.success = false;
        });

      this.loading = false;
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
    }),
    getOrderLines: {
      get(): Array<OrderLines> {
        return this.data.orderLines;
      },
      set(value: Array<OrderLines>) {
        this.data.orderLines = value;
      },
    },
    getActivateReceivedGoods: {
      get(): boolean {
        return this.receivedGoodsEnabled;
      },
      set(val: boolean) {
        this.receivedGoodsEnabled = val;
      },
    },
  },

  components: {
    BaseView,
    BaseHeadline,
    OrderInfoCard,
    OrderList,
  },
});
</script>

<style lang="scss" scoped>
.btnSticky {
  position: -webkit-sticky;
  position: sticky;
  //bottom: 65px;
  bottom: calc(50px + env(safe-area-inset-bottom));
  z-index: 2;
}
</style>
